import React from 'react';
import { Box, Stack } from '@mui/material';
import { ConfirmationNumberOutlined } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import {
  TitleEdit,
  DescriptionEdit,
  TagsEdit
} from '../fields';

/**
 * TicketInformationSection - Contains the core ticket identification fields
 * Includes title, description, and tags
 * Status has been moved to the Resolution tab
 */
export const TicketInformationSection: React.FC = () => {
  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<ConfirmationNumberOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Ticket Information"
      />
      
      <SectionPaper>
        <Stack spacing={2}>
          {/* Title on its own row for full width */}
          <TitleEdit required={true} />
          
          {/* Description gets full width for better usability */}
          <DescriptionEdit required={true} />
          
          {/* Tags for categorization */}
          <TagsEdit />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default TicketInformationSection;
